/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import {getMode, getSetting, navigate} from '@dvrd/dvr-controls'

export function onConnectBolOauth(fakeFlow: boolean = false) {
    if (getMode() !== 'prod' && fakeFlow) return navigate('/oauth/bol');
    const clientId = getSetting('bolOauthClientId');
    if (!clientId) throw new Error('Bol OAuth client id is not set');
    const oauthState = getSetting('oauthState');
    const redirectUri = encodeURIComponent('https://app.bolmate.nl/oauth/bol');
    let uri = `https://login.bol.com/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&prompt=login`;
    if (oauthState !== null) uri += `&state=${oauthState}`;
    window.location.assign(uri);
}